import React from 'react';

import { AnimatedLineSeries } from '@visx/xychart';

import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { PIPLELINES_TIMESERIES_DATA_LENGTH } from 'src/components/pipelines/hooks/use-pipelines-timeseries';

type AverageLineSeriesProps = {
  chartTitle: string;
  display: boolean;
  average: number;
};

type AverageLineData = {
  index: number;
  average: number;
};

const getAverageLineData = (average: number): AverageLineData[] => {
  const lineData = [];
  for (let index = 0; index < PIPLELINES_TIMESERIES_DATA_LENGTH; index++) {
    lineData.push({
      index,
      average,
    });
  }
  return lineData;
};

/* eslint @typescript-eslint/ban-types: "warn" */
export const AverageLineSeries: React.FC<AverageLineSeriesProps> = ({
  chartTitle,
  display,
  average,
}) => {
  if (!display) return null;

  return (
    <AnimatedLineSeries
      dataKey={`${chartTitle} average`}
      data={getAverageLineData(average)}
      xAccessor={(d: AverageLineData) => d.index}
      yAccessor={(d: AverageLineData) => d.average}
      enableEvents={false}
      stroke={token('color.text.disabled', colors.N70)}
      strokeDasharray={5}
    />
  );
};
